import React from 'react';

import MetricBox from './MetricBox';

interface WindSpeedIndicatorProps {
  metersPerSecond: number;
}

const WindSpeedIndicator: React.FC<WindSpeedIndicatorProps> = ({ metersPerSecond }) => {
  const knots = metersPerSecond * 1.94384;
  const color: 'normal' | 'warning' | 'danger' = knots > 30 ? 'danger' : knots > 20 ? 'warning' : 'normal';
  return <MetricBox label='Wind' value={`${knots.toFixed(1)} kt`} color={color} />;
};

export default WindSpeedIndicator;
